
import { useState, useEffect } from "react";

interface HeroProps {
  isScrolled: boolean;
}

export default function Hero({ isScrolled }: HeroProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c725a0bb1d84990daa795da077229e9b.jpg"
          alt="Professional Tax Consulting"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2F4858]/85 via-[#2F4858]/75 to-[#2F4858]/85"></div>
      </div>

      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? "bg-white shadow-lg" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center">
              <img
                src="https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/507ad711238d1ff66498f69658d73c1b.png"
                alt="HOMMEN Consulting Logo"
                className="h-12 w-auto"
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a
                href="#services"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? "text-[#2F4858] hover:text-[#FF6B35]" : "text-white hover:text-[#FF6B35]"
                }`}
              >
                Leistungen
              </a>
              <a
                href="#solutions"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? "text-[#2F4858] hover:text-[#FF6B35]" : "text-white hover:text-[#FF6B35]"
                }`}
              >
                E-Commerce Lösungen
              </a>
              <a
                href="#benefits"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? "text-[#2F4858] hover:text-[#FF6B35]" : "text-white hover:text-[#FF6B35]"
                }`}
              >
                Vorteile
              </a>
              <a
                href="#testimonials"
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? "text-[#2F4858] hover:text-[#FF6B35]" : "text-white hover:text-[#FF6B35]"
                }`}
              >
                Referenzen
              </a>
              <a
                href="#contact"
                className="px-6 py-2.5 bg-[#FF6B35] text-white text-sm font-medium rounded-full hover:bg-[#e55a2a] transition-colors whitespace-nowrap cursor-pointer"
              >
                Kontakt
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Ihr Spezialist für<br />
            <span className="text-[#FF6B35]">E-Commerce Buchführung</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed">
            Professionelle Buchführungs- und Compliance-Dienstleistungen für Onlinehändler: Egal ob "FBA Hero" oder "Multichannel Rockstar", wir unterstützen Sie mit fundierter Expertise bei der Einhaltung Ihrer gesetzlichen Verpflichtungen in den Bereichen Accounting und Tax Compliance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="#contact"
              className="px-8 py-4 bg-[#FF6B35] text-white text-base font-semibold rounded-full hover:bg-[#e55a2a] transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Kostenlose Erstberatung
            </a>
            <a
              href="#services"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-full hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              Unsere Leistungen
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
